import * as React from 'react';

import ArrowDownSvg from '../Svg/arrowDown';
import ArrowUpSvg from '../Svg/arrowUp';

import './Collapsible.scss';

class Collapsible extends React.Component<Collapsible.IProps, Collapsible.IState> {
  animationTime = 500;
  element = React.createRef<HTMLDivElement>();

  state = { animationTime: this.props.animationTime || this.animationTime, showContent: this.props.showOpen || false };

  componentDidMount() {
    return this._animation();
  }

  render() {
    const { trigger, children, className, onClickCapture, contentClassName, arrowClassName, onOpen, ...rest } = this.props;

    if (!children) {
      return null;
    }

    return (
      <div {...rest} className={`collapsible ${className || ''}`}>
        <div
          className="trigger c-pointer-no-color px-2 d-flex justify-content-between align-middle"
          onClick={this._onClick}
          onClickCapture={onClickCapture}
        >
          {trigger}
          {!this.props.disabled && !this.state.showContent && <ArrowDownSvg className={arrowClassName} />}
          {!this.props.disabled && this.state.showContent && <ArrowUpSvg className={arrowClassName} />}
        </div>
        <div className={`content ${contentClassName || 'px-2'}`} style={this.props.showOpen ? {} : { display: 'none' }} ref={this.element}>
          {children}
        </div>
      </div>
    );
  }

  _onClick = async (event: React.MouseEvent<HTMLDivElement>) => {
    if (event.preventDefault) {
      event.preventDefault();
    }
    if (event.persist) {
      event.persist();
    }

    if (this.props.disabled) {
      return undefined;
    }

    if (this.props.onOpen && !this.state.showContent) {
      await this.props.onOpen(event);
    } else if (this.props.onClose && this.state.showContent) {
      await this.props.onClose(event);
    }

    await this.setState({ showContent: !this.state.showContent });

    this._animation();

    return undefined;
  };

  _animation = () => {
    if (!this.element || !this.element.current) {
      return undefined;
    }

    if (this.state.showContent) {
      return $(this.element.current).show(this.state.animationTime);
    }
    return $(this.element.current).hide(this.state.animationTime);
  };
}

export default Collapsible;
